var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "footer-contact" },
    [
      _vm._m(0),
      _c("div", { staticClass: "footer-contact__title" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("footer_4")) + "\n  ")
      ]),
      _c(
        "router-link",
        { attrs: { to: { name: "contact-form" } } },
        [
          _c("button-view", { attrs: { variant: "secondary" } }, [
            _vm._v("\n      " + _vm._s(_vm.$t("button_1")) + "\n    ")
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("figure", { staticClass: "footer-contact__image" }, [
      _c("picture", [
        _c("source", {
          attrs: {
            media: "--small",
            "data-srcset":
              "/static/images/get-in-touch-mobile.jpg,\n        /static/images/get-in-touch-mobile@2x.jpg 2x,\n        /static/images/get-in-touch-mobile@3x.jpg 3x"
          }
        }),
        _c("source", {
          attrs: {
            media: "--large",
            "data-srcset":
              "/static/images/get-in-touch.jpg, /static/images/get-in-touch@2x.jpg 2x"
          }
        }),
        _c("img", {
          staticClass: "lazyload top",
          attrs: {
            "data-sizes": "auto",
            "data-src": "/static/images/get-in-touch.jpg"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb73aa80", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb73aa80","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer-contact-view.vue
// module id = 270
// module chunks = 25 41